import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import VCharts from 'v-charts';
import JsonExcel from 'vue-json-excel'
import 'element-ui/lib/theme-chalk/index.css';
import './router/gloable.css'
import request from './router/request';
import i18n from './lang' // internationalization

Vue.config.productionTip = false
Vue.use(ElementUI,{
	size:"small",
	i18n: (key, value) => i18n.t(key, value)
	});
Vue.use(VCharts);
// Vue.use(VueI18n);
Vue.prototype.request = request;
Vue.component('downloadExcel', JsonExcel);
new Vue({
	el: '#app',
	router,
	i18n,
	render: h => h(App)
}).$mount('#app')
